import { Component } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatExpansionModule } from '@angular/material/expansion'; 
import { RpeNstabComponent } from '../rpe-nsp-mdl/rpe-nstab/rpe-nstab.component';
import { RpeIsentMdlModule } from '../rpe-isent-mdl/rpe-isent-mdl.module';
import { DeflectWeakComponent } from '../rpe-oblique/deflect-weak/deflect-weak.component';
import { DeflectStrongComponent } from '../rpe-oblique/deflect-strong/deflect-strong.component';
import { ShockAngleComponent } from '../rpe-oblique/shock-angle/shock-angle.component';

@Component({
    selector: 'app-rpecalc',
    templateUrl: './rpecalc.component.html',
    styleUrl: './rpecalc.component.scss',
    standalone: true,
    imports: [
        MatTabsModule,      
        MatExpansionModule,
        RpeNstabComponent,
        RpeIsentMdlModule,
        DeflectWeakComponent,
        DeflectStrongComponent,
        ShockAngleComponent
      ]
})
export class RpecalcComponent {

}
